// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import {createApp} from 'vue'
/* 路由 */
import router from './router'
import store from './store'
/* axios */
import axios from './api'
Vue.prototype.http = axios;

/* swiper */
import 'swiper/dist/css/swiper.min.css';

import VueMeta from 'vue-meta'


Vue.use(VueMeta);

/* 重置样式 */
import './assets/css/reset.min.css'

/* jquery */
import 'jquery'

/* bootstarp */
import './assets/css/bootstrap.min.css'
import './assets/js/bootstrap.min.js'

/* animate.css */
import 'animate.css'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

// 引入i18n
import i18n from './i18n'

/* 头部组件 */
import Header from './components/Header'
Vue.component(Header.name,Header)

Vue.use(ElementUI);
/* 尾部组件 */
import Footer from './components/Footer'
Vue.component(Footer.name,Footer)

/* 回到顶部 */
import GoTop from './components/GoTop'
Vue.component(GoTop.name,GoTop)

Vue.config.productionTip = false


router.beforeEach((to, from, next) => {
    if(to.meta.title){
      document.title = to.meta.title
    }
    next();
});


new Vue({
  el: '#app',
  router,
  store,
  i18n, // 添加i18n实例
  components: { App },
  template: '<App/>'
})


// WEBPACK FOOTER //
// ./src/main.js